<script setup lang="ts">
import {computed, ref} from "vue";
import {Button} from "@/Components/Library";
import {useSortable} from "@vueuse/integrations/useSortable";

const props = defineProps<{
    question: {[key: string]: any; options: string[]};
}>();

const model = defineModel();

const orderedOptions = computed(() => model.value.map((i) => props.question.options.find((O) => O.id === i)));
const list = ref<HTMLElement | null>(null);
useSortable(list, model, {
    animation: 150,
});
</script>
<template>
    <div>
        <h3 class="mb-6 mt-1 px-1 text-sm font-bold">Drag and drop the options in to the order you feel is right</h3>
        <div class="flex justify-center">
            <div ref="list">
                <template v-for="(option, i) in orderedOptions" :key="option.id">
                    <div class="flex items-center gap-2 py-2">
                        <Button icon="mdi:drag" class="cursor-move" />
                        <span
                            class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-askr-green font-bold leading-none text-white"
                        >
                            {{ i + 1 }}
                        </span>
                        <div class="px-2">
                            <img
                                v-if="option.image?.url"
                                class="mb-1 h-auto w-full rounded-md"
                                :src="option.image.url"
                                :alt="option.value"
                            />
                            <p class="font-bold">
                                {{ option.value }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
